import * as React from 'react'

const LS_KEY = 'piteas:favorites:v1'
const bus = new EventTarget()

function read(): string[] {
  try {
    const raw = localStorage.getItem(LS_KEY)
    return raw ? JSON.parse(raw) : []
  } catch {
    return []
  }
}

function write(next: string[]) {
  try {
    localStorage.setItem(LS_KEY, JSON.stringify(next))
  } catch {}
  bus.dispatchEvent(new Event('change'))
  // cross-tab sync
  try {
    window.dispatchEvent(new StorageEvent('storage', { key: LS_KEY, newValue: JSON.stringify(next) }))
  } catch {}
}

export function useFavorites() {
  const [favorites, setFavorites] = React.useState<string[]>(() => read())

  React.useEffect(() => {
    const onChange = () => setFavorites(read())
    bus.addEventListener('change', onChange)
    window.addEventListener('storage', onChange)
    return () => {
      bus.removeEventListener('change', onChange)
      window.removeEventListener('storage', onChange)
    }
  }, [])

  const toggle = React.useCallback((id: string) => {
    const key = id.toLowerCase()
    const current = read()
    const next = current.includes(key) ? current.filter((x) => x !== key) : [...current, key]
    write(next)
  }, [])

  const remove = React.useCallback((id: string) => {
    const key = id.toLowerCase()
    write(read().filter((x) => x !== key))
  }, [])

  const clearAll = React.useCallback(() => write([]), [])

  const has = React.useCallback((id: string) => read().includes(id.toLowerCase()), [])

  return { favorites, toggle, remove, clearAll, has }
}
